export default "__VITE_ASSET__QXkIs7oR__"